import { Form } from 'react-bootstrap';
import styled from 'styled-components';

import formatMoneyValue from '../../utils/formatMoneyValue';
import LoopSpinner from '../LoopSpinner';

const StyledTariffRatesBox = styled.div`
  border: 1px solid ${(props) => props.theme.colors.light};
  border-radius: 4px;
  padding: 16px;
  font-size: 16px;
`;

const StyledTariffValueText = styled.p`
  margin-bottom: 0px;
`;

const StyledTariffValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0px;
  }
`;

export const isRateEmpty = (tariffRates) => {
  if (!tariffRates) return true;
  if (tariffRates?.day === 0 && tariffRates?.cheap === 0 && tariffRates?.peak === 0) return true;
  return false;
};

const TariffRatesDisplay = ({ loading, tariffRates, label = 'rates for this tariff' }) => {
  // If we haven't selected a tariff we don't need to show anything yet
  if (!loading && isRateEmpty(tariffRates)) return <></>;
  // otherwise we show a loading state or the tariff info
  return (
    <>
      <Form.Label>{label}</Form.Label>
      <StyledTariffRatesBox>
        {loading && (
          <div className="text-center">
            <LoopSpinner />
          </div>
        )}
        {!loading && tariffRates && (
          <>
            <StyledTariffValueContainer>
              <StyledTariffValueText>Day rate:</StyledTariffValueText>

              {tariffRates.day.min === tariffRates.day.max ? (
                <StyledTariffValueText>{formatMoneyValue(tariffRates.day.min)} / kWh</StyledTariffValueText>
              ) : (
                <StyledTariffValueText>
                  {formatMoneyValue(tariffRates.day.min)} - {formatMoneyValue(tariffRates.day.max)} / kWh
                </StyledTariffValueText>
              )}
            </StyledTariffValueContainer>
            <StyledTariffValueContainer>
              <StyledTariffValueText>Cheap rate:</StyledTariffValueText>
              {tariffRates.cheap.min === tariffRates.cheap.max ? (
                <StyledTariffValueText>{formatMoneyValue(tariffRates.cheap.min)} / kWh</StyledTariffValueText>
              ) : (
                <StyledTariffValueText>
                  {formatMoneyValue(tariffRates.cheap.min)} - {formatMoneyValue(tariffRates.cheap.max)} / kWh
                </StyledTariffValueText>
              )}
            </StyledTariffValueContainer>
            <StyledTariffValueContainer>
              <StyledTariffValueText>Peak rate:</StyledTariffValueText>
              {tariffRates.peak.min === tariffRates.peak.max ? (
                <StyledTariffValueText>{formatMoneyValue(tariffRates.peak.min)} / kWh</StyledTariffValueText>
              ) : (
                <StyledTariffValueText>
                  {formatMoneyValue(tariffRates.peak.min)} - {formatMoneyValue(tariffRates.peak.max)} / kWh
                </StyledTariffValueText>
              )}
            </StyledTariffValueContainer>
          </>
        )}
      </StyledTariffRatesBox>
    </>
  );
};

export default TariffRatesDisplay;
